interface HistoricalEvent {
  title: string;
  description: string;
  category?: string;
}

const historicalDatabase: Record<number, HistoricalEvent[]> = {
  1969: [
    {
      title: "Moon Landing",
      description:
        "Apollo 11 mission successfully lands humans on the Moon. Neil Armstrong becomes the first person to walk on the lunar surface.",
      category: "Space",
    },
    {
      title: "Woodstock Festival",
      description:
        "The iconic Woodstock music festival takes place in New York, defining a generation of music lovers.",
      category: "Culture",
    },
    {
      title: "Stonewall Uprising",
      description:
        "The Stonewall riots in New York City mark a pivotal moment in the LGBTQ+ rights movement.",
      category: "Rights",
    },
  ],
  1989: [
    {
      title: "Fall of the Berlin Wall",
      description:
        "The Berlin Wall falls, symbolizing the end of Cold War divisions and leading to German reunification.",
      category: "History",
    },
    {
      title: "World Wide Web Invented",
      description:
        "Tim Berners-Lee invents the World Wide Web at CERN, revolutionizing information sharing.",
      category: "Technology",
    },
    {
      title: "Tiananmen Square Protests",
      description:
        "Pro-democracy demonstrations in Beijing attract international attention and lead to significant political changes.",
      category: "Politics",
    },
  ],
  2001: [
    {
      title: "September 11 Attacks",
      description:
        "Terrorist attacks on the World Trade Center and Pentagon change the course of global politics.",
      category: "History",
    },
    {
      title: "iPod Released",
      description:
        "Apple releases the iPod, revolutionizing portable music and digital media.",
      category: "Technology",
    },
    {
      title: "Wikipedia Founded",
      description:
        "Wikipedia launches, creating the world's largest free online encyclopedia.",
      category: "Internet",
    },
  ],
  2008: [
    {
      title: "Global Financial Crisis",
      description:
        "The subprime mortgage crisis triggers the worst economic recession since the Great Depression.",
      category: "Economy",
    },
    {
      title: "Barack Obama Elected",
      description:
        "Barack Obama becomes the first African American President of the United States.",
      category: "Politics",
    },
    {
      title: "First iPhone Released",
      description:
        "Apple releases the iPhone, revolutionizing mobile computing and smartphones.",
      category: "Technology",
    },
  ],
  2020: [
    {
      title: "COVID-19 Pandemic",
      description:
        "The global COVID-19 pandemic transforms society, economies, and daily life worldwide.",
      category: "Health",
    },
    {
      title: "Black Lives Matter Protests",
      description:
        "Massive protests erupt following George Floyd's death, sparking global conversations on racial justice.",
      category: "Rights",
    },
    {
      title: "U.S. Presidential Election",
      description:
        "Joe Biden defeats Donald Trump in a highly contentious presidential election.",
      category: "Politics",
    },
  ],
  1066: [
    {
      title: "Norman Conquest",
      description:
        "William the Conqueror wins the Battle of Hastings, becoming King of England and changing its history.",
      category: "History",
    },
  ],
  1492: [
    {
      title: "Columbus Reaches Americas",
      description:
        "Christopher Columbus's expedition lands in the Caribbean, initiating sustained European exploration and colonization.",
      category: "Exploration",
    },
  ],
  1776: [
    {
      title: "American Independence",
      description:
        "The Declaration of Independence is signed, establishing the United States as an independent nation.",
      category: "History",
    },
  ],
  1859: [
    {
      title: "Darwin's Evolution",
      description:
        "Charles Darwin publishes 'On the Origin of Species,' fundamentally changing our understanding of life.",
      category: "Science",
    },
  ],
  1945: [
    {
      title: "World War II Ends",
      description:
        "Germany surrenders in May, and Japan surrenders in August, ending World War II.",
      category: "History",
    },
  ],
};

export function getEventsForYear(year: number): HistoricalEvent[] {
  return historicalDatabase[year] || [];
}

export function getAllYearsWithEvents(): number[] {
  return Object.keys(historicalDatabase).map(Number).sort((a, b) => a - b);
}
